module.exports = __webpack_public_path__ + "img/isOwner.17264f87.svg";